import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Mail } from "lucide-react";

import PageHero from "@/components/layout/PageHero";
import { VisualSection } from "@/components/layout/visualLayout";
import Reveal from "@/components/common/Reveal";
import ASSETS from "@/lib/assets";

export const ComingSoon = ({ phaseKey, testId }) => {
  const { t } = useTranslation();
  return (
    <div data-testid={testId || "coming-soon-page"}>
      <PageHero
        eyebrow={t("comingSoon.eyebrow")}
        title={t("comingSoon.title")}
        subtitle={t("comingSoon.body", { phase: t(`comingSoon.${phaseKey}`) })}
        image={ASSETS.editorial[2]}
        testId="coming-soon-hero"
      />
      <VisualSection testId="coming-soon-actions" tight>
        <Reveal>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="wit-btn-secondary" data-testid="coming-soon-home">
              <ArrowLeft size={16} /> {t("comingSoon.back")}
            </Link>
            <Link to="/contact" className="wit-btn-primary" data-testid="coming-soon-contact">
              <Mail size={16} /> {t("comingSoon.contact")}
            </Link>
          </div>
        </Reveal>
      </VisualSection>
    </div>
  );
};

export default ComingSoon;
